import { render, staticRenderFns } from "./VisibleDocuments.vue?vue&type=template&id=38bab760&scoped=true&"
import script from "./VisibleDocuments.vue?vue&type=script&lang=js&"
export * from "./VisibleDocuments.vue?vue&type=script&lang=js&"
import style0 from "./VisibleDocuments.vue?vue&type=style&index=0&id=38bab760&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bab760",
  null
  
)

export default component.exports